import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { AuthService } from '@core/services/auth.service';
import { environment as env } from '@environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(
    private router: Router,
    private authService: AuthService,
  ) {}

  canActivate(): Observable<boolean | UrlTree> | boolean | UrlTree {
    if (this.authService.isSignedIn()) {
      return this.authService
        .hasMFA()
        .pipe(
          map((e) => (!e ? this.router.parseUrl(env.appRoutes.signIn) : true)),
        );
    }

    return this.router.parseUrl(env.appRoutes.signIn);
  }
}
